module.exports = __webpack_public_path__ + "static/img/9.8f002f1c.png";